import continuousPreview from 'assets/images/cms/menu-layout-continuous.svg'
import tabsPreview from 'assets/images/cms/menu-layout-tabs.svg'
import contentPreview from 'assets/images/cms/menu_category_preview.svg'
import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'
import PublishBanner from 'scenes/Cms/components/PublishBanner'
import MenuLayoutSection from './components/MenuLayoutSection'
import ProductCardForm from './components/ProductCardForm'
import { FormModel } from './hooks'
import PageForm from './PageForm'
import Sidebar from './Sidebar'
import { MenuLayoutState } from './useMenuLayout'

const t = buildTranslate('cms.content.menu_category')

type Props = {
  data: FormModel
  isFetching: boolean
  isLoading: boolean
  menuLayout: MenuLayoutState
}

const layoutPreviews = {
  tabs: tabsPreview,
  continuous_scroll: continuousPreview,
}

const MenuCategoryPage = ({
  isFetching,
  isLoading,
  data,
  menuLayout,
}: Props) => {
  const sidebarImage = menuLayout.enabled
    ? layoutPreviews[menuLayout.selectedLayout]
    : contentPreview
  const sidebarAlt = menuLayout.enabled
    ? t(`menu_layout.preview_alt.${menuLayout.selectedLayout}`)
    : undefined

  return (
    <CmsPage
      className="mr-m"
      title={t('content.title')}
      description={t('content.description')}
      sidebar={
        <Sidebar
          image={sidebarImage}
          alt={sidebarAlt}
          isLoading={isFetching}
          disabled={isLoading || isFetching}
        />
      }
    >
      <MenuLayoutSection menuLayout={menuLayout} />
      <PageForm isLoading={isLoading} data={data} />
      <ProductCardForm
        isLoading={isLoading}
        data={data.product_card}
        type="product_card"
      />
      <ProductCardForm
        isLoading={isLoading}
        data={data.unavailable_product_card}
        type="unavailable_product_card"
      />

      <PublishBanner
        buttonText={t('footer.publish')}
        isLoading={isLoading}
        disabled={isLoading || isFetching}
        buttonType={'submit'}
      />
    </CmsPage>
  )
}

export default MenuCategoryPage
